import React from 'react';
import { getCaseRegistryVariantQuery } from 'app/edozvola/cases/case-case-registry-form/service/case-registry.queries';
import { useParams } from 'react-router-dom';
import { CASE_TAB_ENUM } from 'app/config/constants';
import CaseCaseRegistryForm from 'app/edozvola/cases/case-case-registry-form/case-case-registry-form';
import CaseCaseRegistryFormV2 from 'app/edozvola/cases/case-case-registry-form/case-case-registry-form-v2';

const CaseCaseRegistry = ({loaderData = null}) => {

  const caseRegistryVariant = loaderData;

  return (
    <>
      <h5 className={'form-header'}>Podaci o predmetu</h5>
      {CASE_TAB_ENUM.CASE_REGISTRY === caseRegistryVariant && <CaseCaseRegistryForm />}
      {CASE_TAB_ENUM.CASE_REGISTRY_V2 === caseRegistryVariant && <CaseCaseRegistryFormV2 />}
    </>
  );
};

export default CaseCaseRegistry;
